// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__nCrk1","brand":"Navbar_brand__LBA4p"};